<template>
  <div class="homeBlog" v-if="blogsDestaque.length">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 col-12">
          <h2 class="ui-home-title ui-home-title--bold">
            Blog COMCASA
          </h2>
        </div>
        <div class="text-center text-lg-right col-md-6 col-12">
          <router-link :to="{name: 'Blog'}">
            <div class="homeBlog__know">
              <label class="d-none d-lg-block"></label>
              Veja mais publicações em nosso blog
            </div>
          </router-link>
        </div>
      </div>
      <BlogCard :blogs="blogsDestaque"></BlogCard>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BlogCard from './BlogCard.vue'
export default {
  components: {
    BlogCard
  },
  computed: {
    ...mapGetters([
      'blogsDestaque'
    ])
  },
  created () {
    this.$store.dispatch('loadDestaques')
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.homeBlog {
  padding: 100px 0 20px 0;
  background: linear-gradient(0deg, $silver 48%,$bgHome 0);
  &__know {
    color: $lead;
    font-size: 18px;
    transition: all 0.3s;
    label {
      border-bottom: 5px $green solid;
      left: 140px;;
      position: absolute;
      top: 8px;
      width: 100px;
    }
    &:hover {
      color: $primary;
      transition: all 0.3s;
    }
  }
  .ui-home-title, .homeBlog__know {
    margin-bottom: 80px;
  }
  @media (max-width: 1200px) {
    padding: 80px 0 20px 0;
    &__know {
      label {
        left: 15px;
      }
    }
    .ui-home-title, .homeBlog__know {
      margin-bottom: 60px;
    }
  }
  @media (max-width: 991px) {
    padding: 60px 0 20px 0;
    .ui-home-title, .homeBlog__know {
      margin-bottom: 40px;
    }
  }
  @media (max-width: 767px) {
    padding: 40px 0 10px 0;
    .ui-home-title {
      margin-bottom: 10px;
      text-align: center;
    }
    .homeBlog__know  {
      margin-bottom: 20px;
    }
    background: linear-gradient(0deg, $silver 80%,$bgHome 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeBlog.vue